$(document).ready(function() {
    
    const cursor = $(".cursor");
    let scale = 1;
    let mouseX = 0;
    let mouseY = 0;

    jQuery.fn.highlight = function (str, className) {    
        var regex = new RegExp(str, "gi");
        return this.each(function () {
            this.innerHTML = this.innerHTML.replace(regex, function(matched) {return "<span class=\"" + className + "\">" + matched + "</span>";});
        });
    };
    $(".page-content").highlight("£","currency-symbol");

    function updateCursor() {
        cursor.css({
            top: mouseY,
            left: mouseX,
            transform: `translate(-50%, -50%) scale(${scale})`
        });
        requestAnimationFrame(updateCursor);
    }

    $(document).on("mousemove", function(e) {
        if ($(window).width() > 768) {
            mouseX = e.clientX;
            mouseY = e.clientY;
        }
    });

    requestAnimationFrame(updateCursor);

    $(document).on({
        "mouseenter mousemove": function() {
            $('.cursor').addClass('outline');
            scale = 1.2;
        },
        "mouseleave": function() {
            $('.cursor').removeClass('outline');
            scale = 1;
        }
    }, "a,button");

    //Announcement Bar
    if (!Cookies.get('announcementBar')) {
        let announcementBarHeight = 0;
        const announcementText = $('.announcement-bar-v2 .announcement-text');
        announcementText.each(function() {
            const textHeight = $(this).outerHeight();
            if(textHeight > announcementBarHeight || !announcementBarHeight){
                announcementBarHeight = textHeight;
            }
        });
        announcementBarHeight = announcementBarHeight + 24;
        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
        $('.announcement-bar-v2').outerHeight(announcementBarHeight);
    }else{
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        setTimeout(function() {
            $('.announcement-bar-v2').remove();
        }, 500);
    }
    $(document).on('click', '.announcement-bar-v2 .close-announcement-bar', function() {
        $('body').addClass('announcement-bar-closing');
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        $('.announcement-bar-v2').outerHeight(0);
        Cookies.set('announcementBar', 'closed', { expires: 7 });
        setTimeout(function() {
            $('body').removeClass('announcement-bar-closing');
            $('.announcement-bar-v2').remove();
        }, 500);
    });
    if($('.announcement-text-slider').length){
        $('.announcement-text-slider').flickity({
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false,
            cellAlign: 'center',
            groupCells: 1,
            autoPlay: 5000,
            pauseAutoPlayOnHover: true
        });
    };

    //Sidebar Menu
    $(document).on('click', '.sidebar-menu-trigger', function() {
        if($(this).parents('.section-header').length && $(this).parents('.section-header').hasClass('cart-open')){
            const cartLink = $('#cart-icon-bubble')[0];
            const cartDrawer = $('cart-drawer')[0];
            cartDrawer.close();
            $('.section-header').removeClass('cart-open');
        }else{
            if($(window).width() < 1025){
                $('body').toggleClass('overflow-hidden');
                $('.section-header').toggleClass('menu-open');
            }
            $(this).toggleClass('open');
            $('.sidebar-menu').toggleClass('open');
        }
    });
    
    // Landing
    function fallingObjects(el, image) {
        const { Engine, Runner, Render, Bodies, Composite, Body } = Matter;
        const engine = Engine.create();
        const canvasWidth = $(el).parent().width() * 2;
        const canvasHeight = $(el).parent().height() * 2;
        const render = Render.create({
            element: el,
            engine: engine,
            options: {
                width: canvasWidth,
                height: canvasHeight,
                pixelRatio: 1,
                background: 'transparent',
                wireframes: false // <-- important
            }
        });
        const images = Array.from({ length: 50 }, (_, i) => {
            const x = Math.random() * canvasWidth; // Random x-coordinate within the canvas width
            const y = i * -100; // Fixed y-coordinate
            return Bodies.rectangle(x, y, 60, 60, {
                render: {
                    sprite: {
                        texture: image,
                        xScale: 1.2, 
                        yScale: 1.2
                    }
                }
            });
        });
        //the images should be stopped from falling through the bottom of the canvas
        const floor = Bodies.rectangle(canvasWidth/2, canvasHeight + 10, canvasWidth, 10, { isStatic: true });
        Composite.add(engine.world, [...images, floor]);
        images.forEach(image => Body.applyForce(image, { x: image.position.x, y: image.position.y }, { x: 0, y: 0.2 }));
        Render.run(render);
        Runner.run(Runner.create(), engine);
    }
    function runFallingObjects() {
        $('#falling-emojis').empty();
        fallingObjects($('#falling-emojis')[0], $('.landing-media').attr('data-emoji'));
    }
    if($('.landing-section').length){
        $('.landing-cta a').hover(function() {
            runFallingObjects();
        }, function() {
            $('#falling-emojis').empty();
        });
    }
    if($('.landing-v2-section').length){
        $('.landing-circle a').hover(function() {
            runFallingObjects();
        }, function() {
            console.log('a');
            $('#falling-emojis').empty();
        });
    }

    //Featured Collection v2
    if($('.featured-collection-v2').length){
        const sectionTitle = $('.section-title');
        const titleWrapper = $('.title-wrapper');
        const animatedLetter = $('.animated-letter');
        let sectionTitleWidth = sectionTitle.width();
        let wrapperWidth = titleWrapper.width();
        let letterWidth = animatedLetter.width();
        let widthDiff = sectionTitleWidth - wrapperWidth;
        let maxLetters = Math.floor(widthDiff / letterWidth);
        function updateLetterContent() {
            if($(window).width() > 768){
                if($(window).width() < 1025){
                    maxLetters = 6;
                }
                const scrollTop = $(window).scrollTop();
                const windowBottom = $(window).scrollTop() + $(window).height();
                if(windowBottom >= $('.featured-collection-v2').offset().top && scrollTop <= $('.featured-collection-v2').offset().top + $('.featured-collection-v2').outerHeight()){
                    let lettersToAdd = Math.floor((windowBottom - $('.featured-collection-v2').offset().top) / 100) + 1;
                    if(lettersToAdd > maxLetters){
                        lettersToAdd = maxLetters;
                    }
                    if(lettersToAdd < 1){
                        lettersToAdd = 1;
                    }
                    let newContent = '';
                    for (var i = 0; i < lettersToAdd; i++) {
                        newContent += animatedLetter.attr('data-letter');
                    }
                    animatedLetter.text(newContent);
                }
            }
        }
        function updateOnResize() {
            animatedLetter.text(animatedLetter.attr('data-letter'));
            sectionTitleWidth = sectionTitle.width();
            wrapperWidth = titleWrapper.width();
            letterWidth = animatedLetter.width();
            widthDiff = sectionTitleWidth - wrapperWidth;
            maxLetters = Math.floor(widthDiff / letterWidth);
            animatedLetter.text(animatedLetter.attr('data-letter'));
            updateLetterContent();
        }
        $(window).on('resize', updateOnResize);
        updateLetterContent();
    }

    //Reviews Section
    $(document).on('mouseenter', '.reviews-box', function() {
        const imageIndex = $(this).index();
        $(this).parents('.reviews-content').next().find('.reviews-photo').eq(imageIndex).addClass('active').siblings().removeClass('active');
    })

    //Alternating Images
    if($('.alternating-images').length){
        let alternatingImagesInterval;
        let order = [2,4,1,3];
        let index = 0;
        function updateImagesList() {
            if($(window).width() < 1025){
                $('.alternating-images-list img:nth-child(n+3)').removeClass('active');
                order = [2,1];
            }
        }
        updateImagesList();
        $(window).on('resize', updateImagesList);
        function alternatingImages() {
            alternatingImagesInterval = setInterval(function() {
                const imagesList = $('.alternating-images-list img:not(.active)');
                const randomNumber = Math.floor(Math.random() * imagesList.length);
                const randomImage = imagesList.eq(randomNumber);
                const imageToAppend = randomImage.clone();
                imageToAppend.css('opacity', 0);
                const imageIndex = $(`.alternating-images-block:nth-child(${order[index]}) img`).attr('data-id');
                $(`.alternating-images-block:nth-child(${order[index]})`).append(imageToAppend);
                randomImage.addClass('active');
                clearInterval(alternatingImagesInterval);
                $(`.alternating-images-block:nth-child(${order[index]}) img[data-id="${imageIndex}"]`).css('opacity', 0);
                setTimeout(function() {
                    imageToAppend.css('opacity', 1);
                }, 100);
                setTimeout(function() {
                    $(`.alternating-images-block:nth-child(${order[index]}) img[data-id="${imageIndex}"]`).remove();
                    $(`.alternating-images-list img[data-id="${imageIndex}"]`).removeClass('active');
                    index = (index + 1) % order.length;
                    alternatingImages();
                }, 1300);
            }, 2000);
        }
        alternatingImages();
    }

    if($('.marquee').length){
        const carousels = $('.marquee');
        const args = {
            accessibility: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            resize: false
        };
        let speed = 0.5;
        carousels.each(function () {
            const carousel = $(this);
            let requestId, direction;
            if (carousel.children().length > 3) {
                const mainTicker = new Flickity(this, args);

                // Set initial position to be 0
                mainTicker.x = 0;

                // Main function that 'plays' the marquee.
                function play() {
                    mainTicker.x = mainTicker.x - speed;
                    mainTicker.settle(mainTicker.x);
                    requestId = window.requestAnimationFrame(play);
                }
                // Start the marquee animation
                play();
            }
        });
    }



    if($('.product-media-slider').length){
        var isMobile = $(window).width() <= 768;
        var $carousel = $('.product-media-slider').flickity({  
            pageDots: false,
            cellAlign: isMobile ? 'center' : 'left',
            imagesLoaded: true,
            wrapAround: true,
            contain: false,
            setGallerySize: false,
            arrowShape: 'M43.5374 6.1979L49.2711 11.883L15.4519 45.6537L100 45.6537V53.8169L15.4519 53.8169L49.2711 87.5876L43.5374 93.2727L0 49.7353L43.5374 6.1979Z',
            on: {
                change: function( index ) {
                    const sliderElement = this.element;
                    $(sliderElement).siblings('.product-thumbs-slider').find('.product-media-slide').eq(index).addClass('is-selected').siblings().removeClass('is-selected');
                    //scroll to thumb
                    const thumbList = $(sliderElement).siblings('.product-thumbs-slider');
                    const thumbTop = thumbList.find('.product-media-slide').eq(index).offset().top;
                    const thumbHeight = thumbList.find('.product-media-slide').eq(index).outerHeight();
                    const thumbBottom = thumbTop + thumbHeight;
                    const thumbListTop = thumbList.offset().top;
                    const thumbListHeight = thumbList.outerHeight();
                    const thumbListBottom = thumbListTop + thumbListHeight;
                    if(thumbTop < thumbListTop){
                        thumbList.animate({ scrollTop: thumbList.scrollTop() - (thumbListTop - thumbTop) }, 300);
                    }else if(thumbBottom > thumbListBottom){
                        thumbList.animate({ scrollTop: thumbList.scrollTop() + (thumbBottom - thumbListBottom) }, 300);
                    }
                }
            }
        });  
        
        const $thumbList = $('.product-thumbs-slider');
        // Function to update the slider based on screen size  
        function updateSlider() {  
            var windowWidth = $(window).width();  
            var $cells;   
            var $thumbCells;  
      
            if (windowWidth <= 768) {  
                // Include all children with .mobile and .both class  
                $cells = $('.product-media-slider-list').children('.mobile-image, .both-image').clone();  
                $thumbCells = $cells.clone();
            } else {  
                // Include all children with .desktop and .both class  
                $cells = $('.product-media-slider-list').children('.desktop-image, .both-image').clone(); 
                $thumbCells = $cells.clone();
            }  
      
            // Remove all existing cells and add the new ones  
            $carousel.flickity('remove', $carousel.find('.product-media-slide')); // Remove existing cells  
            $carousel.flickity('append', $cells); // Append new cells  
            $carousel.flickity('reposition'); // Reposition the slider  

            $thumbList.empty().append($thumbCells);
            $thumbList.find('.product-media-slide').eq(0).addClass('is-selected').siblings().removeClass('is-selected');

            // Select slide matching ?variant= param
            var params = new URLSearchParams(window.location.search);
            var variantId = params.get('variant');
            console.log('[DEBUG] variantId from URL:', variantId);
            console.log('[DEBUG] variantImageMap:', window.variantImageMap);
            if (variantId) {
                var targetImageId = window.variantImageMap && window.variantImageMap[variantId];
                console.log('[DEBUG] targetImageId:', targetImageId);
                var $slides = $carousel.find('.product-media-slide');
                console.log('[DEBUG] slides count:', $slides.length);
                $slides.each(function(index) {
                    var imageId = $(this).attr('data-image-id');
                    console.log('[DEBUG] slide', index, 'imageId:', imageId, 'match:', imageId === targetImageId, 'match loose:', imageId == targetImageId);
                    if (imageId && targetImageId && String(imageId) === String(targetImageId)) {
                        console.log('[DEBUG] MATCH FOUND at index', index);
                        $carousel.flickity('select', index, false, true);
                        $thumbList.find('.product-media-slide').removeClass('is-selected');
                        $thumbList.find('.product-media-slide').eq(index).addClass('is-selected');
                        return false;
                    }
                });
            }
        }

        let mouseDown = false;
        let startY, scrollTop;

        const startDragging = (e) => {
            mouseDown = true;
            startY = e.pageY - $thumbList.offset().top;
            scrollTop = $thumbList.scrollTop();
        };

        const stopDragging = () => {
            mouseDown = false;
        };

        const move = (e) => {
            e.preventDefault();
            if (!mouseDown) return;
            const y = e.pageY - $thumbList.offset().top;
            const scroll = y - startY;
            $thumbList.scrollTop(scrollTop - scroll);
        };

        // Add the event listeners
        $thumbList.on('mousemove', move);
        $thumbList.on('mousedown', startDragging);
        $thumbList.on('mouseup mouseleave', stopDragging);

        $(document).on('click', '.product-thumbs-slider .product-media-slide', function() {
            $(this).addClass('is-selected').siblings().removeClass('is-selected');
            const index = $(this).index();
            $carousel.flickity('select', index);
            //scroll to thumb
            const thumbTop = $(this).offset().top;
            const thumbHeight = $(this).outerHeight();
            const thumbBottom = thumbTop + thumbHeight;
            const thumbListTop = $thumbList.offset().top;
            const thumbListHeight = $thumbList.outerHeight();
            const thumbListBottom = thumbListTop + thumbListHeight;
            if(thumbTop < thumbListTop){
                thumbList.animate({ scrollTop: thumbList.scrollTop() - (thumbListTop - thumbTop) }, 300);
            }else if(thumbBottom > thumbListBottom){
                thumbList.animate({ scrollTop: thumbList.scrollTop() + (thumbBottom - thumbListBottom) }, 300);
            }
        });

        // Track the last window width to check for changes  
        var lastWidth = $(window).width();  
      
        // On window resize  
        $(window).resize(function() {  
            var currentWidth = $(window).width();  
            // Only reinitialize if the width has changed  
            if (currentWidth !== lastWidth) {  
                updateSlider();  
                lastWidth = currentWidth; // Update lastWidth  
            }  
        });  
      
        // Initial call to set up the slider correctly on page load  
        updateSlider();  
        
    }

    /* Review Boxes */
    if($('.reviews-boxes').length){
        $('.reviews-boxes').each(function() {
            const reviewsPhoto = $(this).parent().siblings('.reviews-photos');
            $('.reviews-boxes').flickity({
                pageDots: false,
                cellAlign: 'center',
                prevNextButtons: false,
                imagesLoaded: true,
                wrapAround: true,
                contain: true,
                watchCSS: true,
                on: {
                    change: function( index ) {
                        const sliderElement = this.element;
                        $(sliderElement).siblings('.mobile-slider-navigation').find('.current').text(index + 1);
                        reviewsPhoto.find('.reviews-photo').eq(index).addClass('active').siblings().removeClass('active');
                    }
                }
            });
        });
    }

    /* Featured Collection */
    if($('.featured-collection-v2').length){
        $('.featured-collection-v2 .product-grid').flickity({
            pageDots: false,
            cellAlign: 'center',
            prevNextButtons: false,
            imagesLoaded: true,
            wrapAround: true,
            contain: true,
            watchCSS: true,
            on: {
                change: function( index ) {
                    const sliderElement = this.element;
                    const newIndex = index + 1;
                    const multiplier = 2 * index + 1;
                    $(sliderElement).siblings('.mobile-slider-navigation').find('.current').text(newIndex);
                    if($(this.element).hasClass('product-grid')){
                        const animatedLetter = $(this.element).parents('.featured-collection-v2').find('.animated-letter');
                        let newContent = '';
                        for (var i = 0; i < multiplier; i++) {
                            newContent += animatedLetter.attr('data-letter');
                        }
                        animatedLetter.text(newContent);
                    }
                }
            }
        });
    }

    /* Text with Rows */
    function initActiveRow() {
        if($(window).width() < 1025){
            const descriptionHeight = $('.text-rows .text-row.active').find('.text-row-description p').outerHeight();
            $('.text-rows .text-row.active').find('.text-row-description').outerHeight(descriptionHeight);
        }else{
            $('.text-rows .text-row.active').find('.text-row-description').removeAttr('style');
        }
    }
    if($('.text-rows').length){
        initActiveRow();
        $(window).on('resize', initActiveRow);
        $(document).on('click', '.text-rows .text-row h3', function() {
            if($(window).width() < 1025){
                const parent = $(this).parent();
                const grandParent = parent.parent();
                parent.toggleClass('active');
                grandParent.siblings().find('.text-row-inner').removeClass('active');
                grandParent.siblings().find('.text-row-description').outerHeight(0);
                if(parent.hasClass('active')){
                    $(this).next().outerHeight($(this).next().find('p').outerHeight());
                }else{
                    $(this).next().outerHeight(0);
                }
            }
        });
    }

    $(document).on('click', '.mobile-slider-navigation .slider-next', function() {
        const sliderElement = $(this).parent().prev()[0];
        $(sliderElement).flickity('next');
    });
    $(document).on('click', '.mobile-slider-navigation .slider-prev', function() {
        const sliderElement = $(this).parent().prev()[0];
        $(sliderElement).flickity('previous');
    });

    /* Quantity Selector */
    $(document).on('click', '.cart-item .quantity-value', function(e){
        e.preventDefault();
        $('.cart-item .quantity-value').not(this).removeClass('open');
        $('.cart-item .quantity-options').not($(this).next()).css('height', 0);
        $(this).toggleClass('open');
        if($(this).hasClass('open')){
            $(this).next().css('height', 100);
        }else{
            $(this).next().css('height', 0);
        }
    });
    $(document).on('click', '.quantity-options li', function(e){
        e.preventDefault();
        const quantity = $(this).text();
        const quantityOptions = $(this).parents('.quantity-options');
        const quantityInput = $(this).parents('.quantity-popover-container').find('.quantity__input');
        const cartItems = $(this)[0].closest('cart-items') || $(this)[0].closest('cart-drawer-items');
        const quantityValue = quantityOptions.prev();
        quantityValue.text(quantity);
        quantityInput.val(quantity).change();
        //updateQuantity
        cartItems.updateQuantity(quantityOptions.attr('data-index'), quantity);
        quantityValue.removeClass('open');
        quantityOptions.css('height', 0);
    });

    //Check URL for cart open
    function getUrlParams(url) {
        const params = {};
        const paramArray = url.slice(url.indexOf('?') + 1).split('&');

        for (let i = 0; i < paramArray.length; i++) {
          const param = paramArray[i].split('=');
          params[param[0]] = param[1];
        }
        return params;
    }
    const currentUrl = window.location.href;
    var urlParams = getUrlParams(currentUrl);

    if (urlParams['cart'] === 'open') {
        const cartLink = $('#cart-icon-bubble')[0];
        const cartDrawer = $('cart-drawer')[0];
        cartDrawer.open(cartLink);
        const url = window.location.href;
        const urlWithoutParams = url.substring(0, url.indexOf('?'));
        window.history.replaceState({}, document.title, urlWithoutParams);
    }

    //Click outside event
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.cart-item .quantity-dropdown').length) {
            $('.cart-item .quantity-value').removeClass('open');
            $('.cart-item .quantity-options').css('height', 0);
        }
    });

    //FAQ
    $(document).on('click', '.faq-question', function() {
        $(this).toggleClass('open');
        const siblings = $(this).parent().siblings();
        siblings.find('.faq-question').removeClass('open');
        siblings.find('.faq-answer').css('height', 0);
        if($(this).hasClass('open')){
            $(this).next().css('height', $(this).next().find('.faq-answer-inner').outerHeight());
        }else{
            $(this).next().css('height', 0);
        }
    });

    //Account Page
    $(document).on('click','.recover-link', function(){
        $('#login-form').addClass('hidden');
        $('#recover-form').removeClass('hidden');
    })
    $(document).on('click','.cancel-recover', function(){
        $('#login-form').removeClass('hidden');
        $('#recover-form').addClass('hidden');
    })

    $(document).on('click','#cart-icon-bubble-mobile',function(e){
        e.preventDefault();


        const cartLink = $('#cart-icon-bubble')[0];
        const cartDrawer = $('cart-drawer')[0];
        cartDrawer.open(cartLink);
        $('#CartDrawer .drawer__inner').animate({
            scrollTop: $('#cart-drawer-content').position().top
        }, 0);
        $('.section-header').addClass('cart-open');
    });


    //CSS Vars Functions
    function setAnnouncementBarHeight() {
        let announcementBarHeight = 0;
        const announcementText = $('.announcement-bar-v2 .announcement-text');
        announcementText.each(function() {
            const textHeight = $(this).outerHeight();
            if(textHeight > announcementBarHeight || !announcementBarHeight){
                announcementBarHeight = textHeight;
            }
        });
        if(announcementBarHeight > 0){
            announcementBarHeight = announcementBarHeight + 24;
            document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
        }
    }
    function headerHeightVariableHeight(){
        const headerHeight = $('.section-header').outerHeight();
        let headerHeightVar = headerHeight - $(window).scrollTop();
        if (headerHeightVar < 0) {
            headerHeightVar = 0;
        }
        document.documentElement.style.setProperty('--header-height-variable', headerHeightVar + 'px');
    }
    function landingCaptionHeight() {
        const landingCaptionHeight = $('.landing-caption').outerHeight();
        document.documentElement.style.setProperty('--landing-captions-height', landingCaptionHeight + 'px');
    }
    function newsletterPlaceholder() {
        if ($(window).width() > 1024 ) {
            $(".footer-newsletter input[type='email']").attr("placeholder","your email");
        }
        else { 
            $(".footer-newsletter input[type='email']").attr("placeholder","enter email for updates");
        }
    }
    newsletterPlaceholder();

    //Resize Event
    let resizeTimer;
    let previousWidth = $(window).width();

    $(window).on('resize', function() {
        const currentWidth = $(window).width();

        newsletterPlaceholder();
        $('.sidebar-menu').addClass('no-transition');

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            $('.sidebar-menu').removeClass('no-transition');
        }, 250);

        if (currentWidth !== previousWidth) {
            previousWidth = currentWidth;

            if ($('.announcement-bar-v2').length) {
                setAnnouncementBarHeight();
            }

            if ($('.section-header').length) {
                headerHeightVariableHeight();
            }

            if ($('.landing-caption').length) {
                landingCaptionHeight();
            }
        }
    });


    function mainProductScroll(){
        if($(window).scrollTop() >= $('.main-product').offset().top + $('.main-product').outerHeight() - 300){
            $('.sticky-product-widget').addClass('show');
        }else{
            $('.sticky-product-widget').removeClass('show');
        }
    }
    $(document).on('click','.back-to-product:not(.sticky-add-to-cart)',function(){
        $('html, body').animate({
            scrollTop: $('.product-info').offset().top - 200
        }, 500);
    });

    $(document).on('click', '.sticky-add-to-cart', function(e) {
        e.preventDefault();
        const form = document.querySelector('product-form form');
        if (form) {
            const submitButton = form.querySelector('button[type="submit"]');
            if (submitButton) {
                submitButton.click();
            }
        }
    });



    $(document).on('click', '.sticky-emoji-text button', function() {
        if($(window).width() < 1025){
            const parent = $(this).parents('.text-sticky-emoji-section');
            parent.addClass('popup-expanded');
            const mobilePopup = parent.find('.mobile-popup');
            const currentText = $(this).parents('.sticky-emoji-text');
            const headingText = currentText.find('h3').text();
            const descriptionText = currentText.find('.sticky-emoji-description').text();
            mobilePopup.find('.popup-title').text(headingText);
            mobilePopup.find('.popup-description').text(descriptionText);
            if(parent.hasClass('popup-expanded')){
                const popupHeight = mobilePopup.find('.mobile-popup-inner').outerHeight() + 40;
                mobilePopup.outerHeight(popupHeight).addClass('show');
            }else{
                mobilePopup.outerHeight(0).removeClass('show');
            }
        }
    });
    $(document).on('click', '.mobile-popup-inner .close-popup', function() {
        const parent = $(this).parents('.text-sticky-emoji-section');
        const mobilePopup = parent.find('.mobile-popup');
        mobilePopup.outerHeight(0).removeClass('show');
        parent.removeClass('popup-expanded');
    });

    // Recharge subscription price handling
    function updateAddToCartPrice(price) {
        console.log('Updating add to cart price to:', price);
        
        let mainUpdated = false;
        let stickyUpdated = false;
        
        // 1. Update MAIN product form add to cart button - target the exact structure we found
        const mainProductSelectors = [
            'product-form .atc-price > span:not(.compare-at-price)',
            '.product-form .atc-price > span:not(.compare-at-price)', 
            '.quick-add__submit .atc-price > span:not(.compare-at-price)',
            '.main-product .atc-price > span:not(.compare-at-price)',
            '.atc-price > span:last-child' // Target the last span which should be the actual price
        ];
        
        mainProductSelectors.forEach(selector => {
            if (!mainUpdated) {
                const elements = document.querySelectorAll(selector);
                console.log(`Main product - Found ${elements.length} elements for selector: ${selector}`);
                
                elements.forEach(element => {
                    // Make sure it's not a compare-at-price element
                    if (price && !element.classList.contains('compare-at-price') && element.tagName === 'SPAN') {
                        const oldPrice = element.textContent.trim();
                        element.textContent = price;
                        console.log(`Updated MAIN product element from "${oldPrice}" to "${price}":`, element);
                        mainUpdated = true;
                    }
                });
            }
        });
        
        // 2. Update STICKY add to cart button
        const stickySelectors = [
            '.sticky-add-to-cart .atc-price span:not(.compare-at-price)',
            '.sticky-product-widget .atc-price span:not(.compare-at-price)',
            '.back-to-product .atc-price span:not(.compare-at-price)'
        ];
        
        stickySelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            console.log(`Sticky - Found ${elements.length} elements for selector: ${selector}`);
            
            elements.forEach(element => {
                if (price && !element.classList.contains('compare-at-price')) {
                    element.textContent = price;
                    console.log('Updated STICKY element:', element, 'with selector:', selector);
                    stickyUpdated = true;
                }
            });
        });
        
        // 3. Fallback - try to find any .atc-price elements if above didn't work
        if (!mainUpdated) {
            console.log('Main product price not updated, trying fallback...');
            const fallbackElements = document.querySelectorAll('.atc-price span:not(.compare-at-price)');
            console.log(`Fallback - Found ${fallbackElements.length} .atc-price elements`);
            
            fallbackElements.forEach((element, index) => {
                if (price && !element.classList.contains('compare-at-price')) {
                    element.textContent = price;
                    console.log(`Updated fallback element ${index}:`, element);
                }
            });
        }
        
        console.log(`Update summary - Main: ${mainUpdated}, Sticky: ${stickyUpdated}`);
        
        if (!mainUpdated && !stickyUpdated) {
            console.warn('Could not find any suitable price elements to update');
            // Log all .atc-price elements for debugging
            const allAtcElements = document.querySelectorAll('.atc-price');
            console.log('All .atc-price elements found:', allAtcElements);
        }
    }
    
    // Debug function - you can call this in browser console
    window.testPriceUpdate = function(testPrice) {
        updateAddToCartPrice(testPrice || '$29.99');
    };

    // Quick test function to check current state
    window.checkRechargeState = function() {
        const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        const currentValue = sellingPlanInput ? sellingPlanInput.value : '';
        
        console.log('=== CURRENT RECHARGE STATE ===');
        console.log('Selling plan input:', sellingPlanInput);
        console.log('Current value:', currentValue || 'NONE (One-time)');
        
        if (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.formattedPrices) {
            console.log('Recharge config available:', window.SubscriptionWidgetConfig.formattedPrices);
        } else {
            console.log('❌ No Recharge config found');
        }
        
        return currentValue;
    };

    // Manual function to grab current Recharge price and update buttons
    window.updateFromRecharge = function() {
        console.log('=== MANUAL RECHARGE UPDATE ===');
        
        // Look for the Recharge widget
        const rechargeWidget = document.querySelector('.recharge-subscription-widget');
        const rcSellingPlans = document.querySelector('rc-selling-plans');
        
        if (!rechargeWidget && !rcSellingPlans) {
            console.log('❌ No Recharge widget found');
            return;
        }
        
        const targetElement = rcSellingPlans || rechargeWidget;
        console.log('🎯 Scanning element:', targetElement);
        
        // Get all text content
        const allText = targetElement.textContent || '';
        console.log('📄 All text content:', allText);
        
        // Find all prices
        const prices = allText.match(/£\d+\.?\d*/g) || [];
        console.log('💰 All prices found:', prices);
        
        if (prices.length > 0) {
            // Try to find the "selected" or "active" price
            // Usually the last price or the one that appears most prominently
            const selectedPrice = prices[prices.length - 1];
            console.log('✅ Using price:', selectedPrice);
            updateAddToCartPrice(selectedPrice);
            return selectedPrice;
        } else {
            console.log('❌ No prices found in Recharge widget');
            return null;
        }
    };

    // Auto-trigger function - checks for price changes and updates if different
    window.autoUpdateFromRecharge = function() {
        const currentPrice = window.updateFromRecharge();
        if (currentPrice) {
            console.log('🔄 Auto-updated to:', currentPrice);
        }
    };

    // Smart function that uses Recharge's own data to get the correct price
    window.updateFromRechargeData = function() {
        console.log('=== SMART RECHARGE UPDATE ===');
        
        // Get the current selling plan from the hidden input
        const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        const currentPlanId = sellingPlanInput ? sellingPlanInput.value : '';
        
        console.log('📋 Current selling plan ID:', currentPlanId || 'NONE (One-time purchase)');
        
        // If no selling plan or empty value, use regular product price
        if (!sellingPlanInput || !currentPlanId || currentPlanId === '') {
            console.log('🛒 No subscription selected, reverting to regular price');
            
            // Get regular price from Recharge data or fallback to original button price
            if (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.formattedPrices) {
                const priceData = window.SubscriptionWidgetConfig.formattedPrices;
                for (const variantId in priceData) {
                    const variantData = priceData[variantId];
                    if (variantData.unit) {
                        console.log('✅ Using regular price:', variantData.unit);
                        updateAddToCartPrice(variantData.unit);
                        return variantData.unit;
                    }
                }
            }
            
            // Fallback: try to get original price from the page
            const originalPriceSpan = document.querySelector('.atc-price span:not(.compare-at-price)');
            if (originalPriceSpan && originalPriceSpan.dataset.originalPrice) {
                const originalPrice = originalPriceSpan.dataset.originalPrice;
                console.log('✅ Using stored original price:', originalPrice);
                updateAddToCartPrice(originalPrice);
                return originalPrice;
            }
            
            console.log('⚠️ Could not determine regular price');
            return null;
        }
        
        // Get Recharge's price data for subscription
        if (!window.SubscriptionWidgetConfig || !window.SubscriptionWidgetConfig.formattedPrices) {
            console.log('❌ No Recharge price data found');
            return null;
        }
        
        const priceData = window.SubscriptionWidgetConfig.formattedPrices;
        console.log('💰 Recharge price data:', priceData);
        
        // Find the price for the current plan
        for (const variantId in priceData) {
            const variantData = priceData[variantId];
            if (variantData.sellingPlans && variantData.sellingPlans[currentPlanId]) {
                const planPrice = variantData.sellingPlans[currentPlanId].price;
                console.log('✅ Found subscription price for plan', currentPlanId, ':', planPrice);
                updateAddToCartPrice(planPrice);
                return planPrice;
            }
        }
        
        console.log('❌ No price found for plan ID:', currentPlanId);
        return null;
    };

    // Debug function to watch Recharge widget in real-time
    window.watchRechargeWidget = function() {
        console.log('=== WATCHING RECHARGE WIDGET ===');
        
        const rechargeWidget = document.querySelector('.recharge-subscription-widget');
        if (!rechargeWidget) {
            console.log('No Recharge widget found!');
            return;
        }
        
        console.log('Found Recharge widget:', rechargeWidget);
        
        // Find the rc-selling-plans element
        const rcSellingPlans = document.querySelector('rc-selling-plans');
        if (rcSellingPlans) {
            console.log('Found rc-selling-plans element:', rcSellingPlans);
            
            // Try to listen for ANY event on the rc-selling-plans element
            ['click', 'change', 'input', 'select', 'update'].forEach(eventType => {
                rcSellingPlans.addEventListener(eventType, function(event) {
                    console.log(`🎯 RC Event "${eventType}" detected:`, event);
                    setTimeout(() => {
                        scanForPriceInElement(rcSellingPlans);
                    }, 200);
                }, true); // Use capture phase
            });
            
            // Also listen for ANY click anywhere in the document and check if it's near the RC element
            document.addEventListener('click', function(event) {
                const clickedElement = event.target;
                const isInRecharge = clickedElement.closest('rc-selling-plans') || 
                                   clickedElement.closest('.recharge-subscription-widget');
                
                if (isInRecharge) {
                    console.log('🖱️ Click detected in Recharge area:', clickedElement);
                    setTimeout(() => {
                        scanForPriceInElement(rcSellingPlans);
                    }, 300);
                }
            });
        }
        
        // Watch for ANY changes in the widget
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                console.log('🔍 Recharge widget changed:', mutation.type, mutation);
                
                if (mutation.type === 'childList') {
                    console.log('  Added nodes:', mutation.addedNodes);
                    console.log('  Removed nodes:', mutation.removedNodes);
                }
                
                if (mutation.type === 'characterData') {
                    console.log('  Text changed from:', mutation.oldValue, 'to:', mutation.target.textContent);
                }
                
                // Look for prices after any change
                setTimeout(() => {
                    const allText = rechargeWidget.textContent;
                    const prices = allText.match(/£\d+\.?\d*/g);
                    if (prices) {
                        console.log('💰 Prices found in widget:', prices);
                        // If we found different prices, update to the last one
                        if (prices.length > 1) {
                            const newPrice = prices[prices.length - 1];
                            console.log('🔄 Updating to latest price:', newPrice);
                            updateAddToCartPrice(newPrice);
                        }
                    }
                }, 100);
            });
        });
        
        observer.observe(rechargeWidget, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeOldValue: true,
            characterDataOldValue: true
        });
        
        console.log('👀 Now watching Recharge widget for changes...');
        console.log('Try changing subscription options and watch this console!');
    };

    // Debug function to inspect what's actually on the page
    window.inspectRechargeElements = function() {
        console.log('=== RECHARGE INSPECTION ===');
        
        // Look for any elements that might be Recharge-related
        const possibleSelectors = [
            '[class*="recharge"]',
            '[id*="recharge"]', 
            '[data-recharge]',
            '.rc-widget',
            '.subscription-widget',
            '[class*="subscription"]',
            '[id*="subscription"]',
            'iframe[src*="recharge"]',
            '.shopify-subscription-widget',
            '.product-block'
        ];
        
        possibleSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
                console.log(`Found ${elements.length} elements for: ${selector}`);
                elements.forEach((el, index) => {
                    console.log(`  Element ${index}:`, el);
                    console.log(`  HTML:`, el.outerHTML.substring(0, 200) + '...');
                });
            }
        });
        
        // Look for any price elements
        console.log('\n=== PRICE ELEMENTS ===');
        const priceSelectors = ['.price', '[data-price]', '[class*="price"]'];
        priceSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
                console.log(`Found ${elements.length} price elements for: ${selector}`);
                elements.forEach((el, index) => {
                    console.log(`  Price ${index}: "${el.textContent.trim()}" -`, el);
                });
            }
        });
        
        // Look for current ATC buttons
        console.log('\n=== ADD TO CART BUTTONS ===');
        const atcElements = document.querySelectorAll('.atc-price');
        console.log(`Found ${atcElements.length} .atc-price elements:`);
        atcElements.forEach((el, index) => {
            console.log(`  ATC ${index}:`, el);
            console.log(`  Current text: "${el.textContent.trim()}"`);
            console.log(`  HTML:`, el.outerHTML);
        });
    };

    // Helper function to scan for prices in an element
    function scanForPriceInElement(element) {
        console.log('Scanning for price in element:', element);
        
        // Look for price in various formats within the element
        const priceSelectors = [
            '.price',
            '[data-price]',
            '.rc-price',
            '.subscription-price',
            '.selected-price',
            '[class*="price"]'
        ];
        
        let foundPrice = null;
        
        // First try specific selectors
        priceSelectors.forEach(priceSelector => {
            if (!foundPrice) {
                const priceElement = element.querySelector(priceSelector);
                if (priceElement && priceElement.textContent.trim()) {
                    const priceText = priceElement.textContent.trim();
                    const priceMatch = priceText.match(/£\d+\.?\d*/);
                    if (priceMatch) {
                        foundPrice = priceMatch[0];
                        console.log('Found price:', foundPrice, 'in selector:', priceSelector);
                    }
                }
            }
        });
        
        // If no specific price element found, scan all text content
        if (!foundPrice) {
            const allText = element.textContent || '';
            const priceMatches = allText.match(/£\d+\.?\d*/g);
            if (priceMatches && priceMatches.length > 0) {
                foundPrice = priceMatches[priceMatches.length - 1]; // Get the last price found
                console.log('Found price in text content:', foundPrice);
            }
        }
        
        if (foundPrice) {
            console.log('🎯 Updating ATC price to:', foundPrice);
            updateAddToCartPrice(foundPrice);
        } else {
            console.log('❌ No price found in element');
        }
    }

    // Enhanced Recharge detection
    function setupRechargeListeners() {
        console.log('Setting up Recharge listeners...');
        
        // Method 1: Listen for common Recharge events
        const rechargeEvents = [
            'recharge:subscription_widget:loaded',
            'recharge:subscription_widget:changed',
            'recharge:widget:subscription_changed',
            'recharge:price_changed',
            'recharge_subscription_widget_loaded',
            'recharge_subscription_widget_changed'
        ];
        
        rechargeEvents.forEach(eventName => {
            document.addEventListener(eventName, function(event) {
                console.log('Recharge event detected:', eventName, event.detail);
                if (event.detail && event.detail.price) {
                    updateAddToCartPrice(event.detail.price);
                }
            });
        });

        // Method 2: Monitor for Recharge widget elements and their changes
        function attachRechargeListeners() {
            // PRIORITY: Watch the selling_plan hidden input for changes
            function startSellingPlanWatcher() {
                let lastValue = '';
                const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
                if (sellingPlanInput) {
                    lastValue = sellingPlanInput.value;
                    console.log('🎯 Found selling_plan input with value:', lastValue);
                }
                
                // Fast polling approach - check every 100ms
                setInterval(() => {
                    const currentInput = document.querySelector('input[name="selling_plan"]');
                    const currentValue = currentInput ? currentInput.value : '';
                    
                    if (currentValue !== lastValue) {
                        console.log('🔄 Selling plan changed from', lastValue || 'NONE', 'to', currentValue || 'NONE (One-time)');
                        lastValue = currentValue;
                        // Update immediately, no delay
                        window.updateFromRechargeData();
                    }
                }, 100);
            }
            
            // Start the watcher
            startSellingPlanWatcher();
            
            // Target the specific Recharge custom elements we found
            const rechargeSelectors = [
                'recharge-subscription-widget',  // The actual custom element!
                'rc-selling-plans',
                '.recharge-subscription-widget',
                '[id*="recharge_subscriptions"]',
                '.shopify-app-block.recharge-subscription-widget',
                '[data-recharge]',
                '.recharge-widget', 
                '.rc-widget',
                '.shopify-subscription-widget',
                '.subscription-widget',
                '[class*="recharge"]',
                '[id*="recharge"]',
                '.subscription-selector',
                '.rc_widget'
            ];
            
            rechargeSelectors.forEach(selector => {
                const elements = document.querySelectorAll(selector);
                console.log(`Found ${elements.length} elements for selector: ${selector}`);
                
                elements.forEach(element => {
                    console.log('Setting up listeners for Recharge element:', element);
                    
                    // Special handling for rc-selling-plans custom element
                    if (element.tagName === 'RC-SELLING-PLANS') {
                        console.log('Found rc-selling-plans custom element!');
                        
                        // Listen for custom events that web components often emit
                        const customEvents = ['change', 'select', 'update', 'rc-change', 'rc-select', 'plan-changed', 'selling-plan-changed'];
                        customEvents.forEach(eventName => {
                            element.addEventListener(eventName, function(event) {
                                console.log(`🎯 RC custom event "${eventName}":`, event);
                                setTimeout(() => {
                                    scanForPriceInElement(element);
                                }, 100);
                            });
                        });
                        
                        // Also try to access shadow DOM if it exists
                        if (element.shadowRoot) {
                            console.log('Found shadow DOM in rc-selling-plans');
                            const shadowInputs = element.shadowRoot.querySelectorAll('input, select, button, [role="button"]');
                            console.log(`Found ${shadowInputs.length} inputs in shadow DOM`);
                            
                            shadowInputs.forEach(input => {
                                ['change', 'click', 'input'].forEach(eventType => {
                                    input.addEventListener(eventType, function() {
                                        console.log(`Shadow DOM ${eventType} event:`, input);
                                        setTimeout(() => {
                                            scanForPriceInElement(element);
                                        }, 100);
                                    });
                                });
                            });
                        }
                    }
                    
                    // Regular DOM handling for other elements
                    const inputs = element.querySelectorAll('input, select, button, [role="button"]');
                    console.log(`Found ${inputs.length} interactive elements in Recharge widget`);
                    
                    inputs.forEach(input => {
                        ['change', 'click', 'input'].forEach(eventType => {
                            input.addEventListener(eventType, function() {
                                console.log(`Recharge ${eventType} event on:`, input);
                                setTimeout(() => {
                                    scanForPriceInElement(element);
                                }, 100);
                            });
                        });
                    });
                    
                    // Also set up a MutationObserver specifically for this Recharge widget
                    const rechargeObserver = new MutationObserver(function(mutations) {
                        mutations.forEach(function(mutation) {
                            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                                console.log('Recharge widget DOM changed:', mutation);
                                setTimeout(() => {
                                    // Scan for any price changes in the widget
                                    const allText = element.textContent;
                                    const priceMatch = allText.match(/£\d+\.?\d*/g);
                                    if (priceMatch && priceMatch.length > 0) {
                                        const latestPrice = priceMatch[priceMatch.length - 1]; // Get the last price found
                                        console.log('Price detected in Recharge widget mutation:', latestPrice);
                                        updateAddToCartPrice(latestPrice);
                                    }
                                }, 200);
                            }
                        });
                    });
                    
                    rechargeObserver.observe(element, {
                        childList: true,
                        subtree: true,
                        characterData: true
                    });
                });
            });
        }

        // Method 3: Monitor for selling plan changes (Shopify native subscriptions)
        document.addEventListener('change', function(event) {
            if (event.target.name === 'selling_plan' || 
                event.target.getAttribute('name') === 'selling_plan' ||
                event.target.classList.contains('selling-plan-input')) {
                
                console.log('Selling plan changed:', event.target.value);
                
                // Look for associated price
                const form = event.target.closest('form');
                if (form) {
                    const priceElement = form.querySelector('.price, [data-price]');
                    if (priceElement) {
                        updateAddToCartPrice(priceElement.textContent.trim());
                    }
                }
            }
        });

        // Method 4: Monitor any changes in the product blocks area
        const productBlocksContainer = document.querySelector('.product-info');
        if (productBlocksContainer) {
            const productObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        // Look for any price changes in the product area
                        setTimeout(() => {
                            const allPriceElements = productBlocksContainer.querySelectorAll(
                                '.price, [data-price], .subscription-price, .rc-price, [class*="price"]'
                            );
                            
                            allPriceElements.forEach(priceEl => {
                                if (priceEl.textContent && priceEl.textContent.includes('$')) {
                                    console.log('Potential price found in product area:', priceEl.textContent.trim());
                                }
                            });
                        }, 200);
                    }
                });
            });
            
            productObserver.observe(productBlocksContainer, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }

        // Method 5: Generic input listener for the entire product area
        document.addEventListener('change', function(event) {
            // If any input changes in the product area, look for price updates
            const productArea = event.target.closest('.product-info, .main-product, .product-form');
            if (productArea) {
                setTimeout(() => {
                    console.log('Input changed in product area, scanning for prices...');
                    
                    // Look for any visible price elements that might have been updated
                    const priceElements = productArea.querySelectorAll(
                        '.price:not(.compare-at-price), [data-price], .subscription-price, .rc-price'
                    );
                    
                    priceElements.forEach(priceEl => {
                        const priceText = priceEl.textContent.trim();
                        if (priceText && priceText.includes('$') && priceText !== '') {
                            console.log('Found updated price:', priceText);
                            updateAddToCartPrice(priceText);
                        }
                    });
                }, 300);
            }
        });

        // Method 6: Listen for Recharge-specific form changes (based on funnelinsiders.com approach)
        document.addEventListener('change', function(event) {
            // Check if this is a Recharge-related input
            const inputName = event.target.name || '';
            const inputId = event.target.id || '';
            
            if (inputName.includes('shipping_interval') || 
                inputId.includes('shipping_interval') ||
                inputName.includes('subscription') ||
                inputId.includes('subscription') ||
                event.target.hasAttribute('data-recharge')) {
                
                console.log('Recharge subscription input detected:', event.target);
                
                // Look for associated price in the form or nearby elements
                const form = event.target.closest('form');
                const container = event.target.closest('.product-block, .recharge-widget, [data-recharge]');
                
                setTimeout(() => {
                    let foundPrice = null;
                    
                    // Search in form first
                    if (form) {
                        const formPrices = form.querySelectorAll('.price, [data-price], .subscription-price');
                        formPrices.forEach(priceEl => {
                            const priceText = priceEl.textContent.trim();
                            if (priceText && priceText.includes('$') && !foundPrice) {
                                foundPrice = priceText;
                            }
                        });
                    }
                    
                    // Search in container
                    if (!foundPrice && container) {
                        const containerPrices = container.querySelectorAll('.price, [data-price], .subscription-price');
                        containerPrices.forEach(priceEl => {
                            const priceText = priceEl.textContent.trim();
                            if (priceText && priceText.includes('$') && !foundPrice) {
                                foundPrice = priceText;
                            }
                        });
                    }
                    
                    if (foundPrice) {
                        console.log('Found Recharge subscription price:', foundPrice);
                        updateAddToCartPrice(foundPrice);
                    }
                }, 100);
            }
        });

        // Method 7: Monitor for form submissions that might be Recharge-related
        document.addEventListener('submit', function(event) {
            const form = event.target;
            const formData = new FormData(form);
            
            // Check if this form has Recharge properties
            let hasRechargeProps = false;
            for (let [key, value] of formData.entries()) {
                if (key.includes('shipping_interval') || key.includes('subscription')) {
                    hasRechargeProps = true;
                    console.log('Recharge form submission detected with property:', key, value);
                    break;
                }
            }
            
            if (hasRechargeProps) {
                // Look for price in the form before submission
                const priceElements = form.querySelectorAll('.price, [data-price], .subscription-price');
                priceElements.forEach(priceEl => {
                    const priceText = priceEl.textContent.trim();
                    if (priceText && priceText.includes('$')) {
                        console.log('Recharge form price at submission:', priceText);
                        updateAddToCartPrice(priceText);
                    }
                });
            }
        });

        // Initial setup
        attachRechargeListeners();

        // Re-run when new elements are added to DOM
        const observer = new MutationObserver(function(mutations) {
            let shouldReattach = false;
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) { // Element node
                            const hasRecharge = node.querySelector && (
                                node.querySelector('[data-recharge]') ||
                                node.querySelector('.recharge-widget') ||
                                node.querySelector('[class*="recharge"]') ||
                                node.classList.contains('recharge-widget') ||
                                node.hasAttribute('data-recharge')
                            );
                            if (hasRecharge) {
                                shouldReattach = true;
                            }
                        }
                    });
                }
            });
            
            if (shouldReattach) {
                console.log('Recharge elements detected, reattaching listeners...');
                setTimeout(attachRechargeListeners, 500);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupRechargeListeners);
    } else {
        setupRechargeListeners();
    }

    // BRUTE FORCE APPROACH - Watch for ANY changes and scan for prices
    function startBruteForceWatcher() {
        console.log('Starting brute force price watcher...');
        
        let lastKnownPrices = new Set();
        
        function scanForPrices() {
            // Look for ANY price-like text on the page
            const allElements = document.querySelectorAll('*');
            const currentPrices = new Set();
            
            allElements.forEach(el => {
                const text = el.textContent?.trim() || '';
                // Look for price patterns like $XX.XX
                const priceMatch = text.match(/\$\d+\.?\d*/);
                if (priceMatch && el.offsetParent !== null) { // visible element
                    const price = priceMatch[0];
                    currentPrices.add(price);
                    
                    // If this is a new price we haven't seen, log it
                    if (!lastKnownPrices.has(price)) {
                        console.log('New price detected:', price, 'in element:', el);
                        
                        // Check if this element is in the product area
                        const inProductArea = el.closest('.product-info, .main-product, .product-block');
                        if (inProductArea) {
                            console.log('Price is in product area, updating ATC button...');
                            updateAddToCartPrice(price);
                        }
                    }
                }
            });
            
            lastKnownPrices = currentPrices;
        }
        
        // Scan immediately
        scanForPrices();
        
        // Scan every 2 seconds
        setInterval(scanForPrices, 2000);
        
        // Also scan on any click or change
        document.addEventListener('click', () => setTimeout(scanForPrices, 500));
        document.addEventListener('change', () => setTimeout(scanForPrices, 500));
    }
    
    // Start the brute force watcher
    setTimeout(startBruteForceWatcher, 1000);

    // POLLING APPROACH - Check for price changes every 3 seconds
    function startPollingWatcher() {
        console.log('Starting polling price watcher...');
        
        let lastSeenPrices = new Set();
        
        function checkForPriceChanges() {
            const rcElement = document.querySelector('rc-selling-plans');
            if (rcElement) {
                const allText = rcElement.textContent || '';
                const currentPrices = allText.match(/£\d+\.?\d*/g) || [];
                
                currentPrices.forEach(price => {
                    if (!lastSeenPrices.has(price)) {
                        console.log('🔄 New price detected via polling:', price);
                        updateAddToCartPrice(price);
                    }
                });
                
                lastSeenPrices = new Set(currentPrices);
            }
        }
        
        // Check immediately and then every 3 seconds
        checkForPriceChanges();
        setInterval(checkForPriceChanges, 3000);
    }
    
    // Start polling after a delay
    setTimeout(startPollingWatcher, 2000);

    $(window).on('scroll', function() {
        if ($('.landing-caption').length) {
            landingCaptionHeight();
        }

        if($('.featured-collection-v2').length){
            updateLetterContent();
        }

        if($('.main-product').length){
            mainProductScroll();
        }
        //Text with Circles
        if($('.text-with-circles').length){
            //if scrollTop past .sticky-images, make it fixed and set the top position to scroll position
            const scrollTop = $(window).scrollTop();
            const scrollBottom = scrollTop + $(window).height();
            const stickyImageTop = $('.text-with-circles .sticky-images').offset().top;
            const bottomSpace = $(window).outerHeight() - $('.text-with-circles .sticky-images-inner').outerHeight() - 40;
            const mainContent = $('#MainContent').offset().top + $('#MainContent').outerHeight() + bottomSpace;
            if(scrollBottom >= mainContent){
                $('.text-with-circles .sticky-images-inner').css({
                    'position': 'fixed',
                    'top': mainContent - scrollBottom + 20
                });
            }else if(scrollTop >= stickyImageTop - 20){
                const stickyImageTotal = $('.text-with-circles .sticky-images .sticky-image').length;
                const heightToScroll = $('#MainContent').offset().top + $('#MainContent').outerHeight() - stickyImageTop;
                const perHeight = heightToScroll / stickyImageTotal;
                const scrollDiff = scrollTop - stickyImageTop;
                const opacityLevel = Math.round((scrollDiff % perHeight) / perHeight * 10) / 10;;
                const leavingIndex = Math.floor(scrollDiff / perHeight);
                const enteringIndex = leavingIndex + 1;
                if(leavingIndex >= 0){
                    $('.text-with-circles .sticky-images .sticky-image').eq(leavingIndex).css('opacity', 1 - opacityLevel);
                }
                if(enteringIndex < stickyImageTotal && enteringIndex > 0){
                    $('.text-with-circles .sticky-images .sticky-image').eq(enteringIndex).css('opacity', opacityLevel);
                }
                $('.text-with-circles .sticky-images-inner').css({
                    'position': 'fixed',
                    'top': '20px'
                });
            }else{
                $('.text-with-circles .sticky-images-inner').css({
                    'position': 'absolute',
                    'top': 0
                });
            }
        }

        if($('.landing-captions').length){
            if($(window).scrollTop() >= 50){
                $('.landing-captions').addClass('solution');
            }else{
                $('.landing-captions').removeClass('solution');
            }
        }

        if($('.landing-v2-text').length){
            if($(window).scrollTop() >= 50){
                $('.landing-v2-section .landing-circle').addClass('solution');
            }else{
                $('.landing-v2-section .landing-circle').removeClass('solution');
            }
        }
        
    });

    $(document).on('click', '.open-chat-popup', function() {
        const shadowHost = document.querySelector('inbox-online-store-chat');
        const shadowRoot = shadowHost.shadowRoot;
        const button = shadowRoot.querySelector('button');
        button.click();
        $('#shopify-chat').addClass('open');
    });

    setTimeout(function() {
        const chatElement = document.querySelector('inbox-online-store-chat');
        const chatObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'is-open') {
            const isOpen = chatElement.getAttribute('is-open');
            
            // If is-open is 'false', remove the .open class from the parent
            if (isOpen === 'false') {
                const parentElement = chatElement.parentElement;
                if (parentElement.classList.contains('open')) {
                parentElement.classList.remove('open');
                }
            }
            }
        });
        });

        chatObserver.observe(chatElement, {
            attributes: true // Watch for attribute changes
        });
    }, 1000);

    if($('body').hasClass('template-product')){
        const subscriptionObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    $('.shopify_subscriptions_app_block_label').first().addClass('is-selected');
                }
            });
        });

        subscriptionObserver.observe(document.querySelector('.shopify_subscriptions_app_block_container'));
    }

});
